module.exports = __webpack_public_path__ + "images/8ce760f2be762c6278ad3ef664abc3a8.png";